import Marionette from "../../shared/marionette-mustache";
import { FileStatusModel } from "../models/file-status";
import { backboneViewProperties } from "../../decorators/backbone-properties";

const template = require<string>("./file-status.html");

@backboneViewProperties({
    tagName: "li",
    template: template
})
export class FileStatusView extends Marionette.ItemView<FileStatusModel> {

    public template: string;
    constructor(options?: Backbone.ViewOptions<FileStatusModel>) {
        super(options);
    }

}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/import-status/views/file-status.ts